// extracted by mini-css-extract-plugin
export default {"featuredTitle":"Featured_featuredTitle__Ltesd"};